/**
 * Query key factory for books queries
 * Follows TanStack Query best practices for hierarchical keys
 */
export const booksKeys = {
    all: ["books"] as const,
    archivedCount: () => [...booksKeys.all, "archivedCount"] as const,
    archivedList: () => [...booksKeys.all, "archivedList"] as const,
    detail: (id: string) => [...booksKeys.details(), id] as const,
    details: () => [...booksKeys.all, "detail"] as const,
    forMonth: (year: number, month: number) => [...booksKeys.all, "forMonth", year, month] as const,
    list: (filters?: { search?: string; sort?: string }) => [...booksKeys.lists(), filters ?? {}] as const,
    lists: () => [...booksKeys.all, "list"] as const,
    unscheduled: () => [...booksKeys.all, "unscheduled"] as const,
    visible: () => [...booksKeys.all, "visible"] as const,
};
